function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
const Button = styled.button.withConfig({
  componentId: "sc-1v62o0r-0"
})(["background:0;border:0;padding:0;margin:0;text-align:inherit;cursor:pointer;color:inherit;text-decoration:none;&[disabled]{cursor:not-allowed;}"]);
/**
 * Use when a button is needed for accessibility purposes but no button styles are desired.
 */

const A11y = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Button, _extends({
  ref: ref,
  tabIndex: "0",
  as: props.disabled ? "button" : props.href ? "a" : "button"
}, props), props.children));
A11y.displayName = "A11y";
A11y.defaultProps = {
  type: "button"
};
A11y.propTypes = {
  /** The button contents */
  children: PropTypes.node.isRequired,

  /** The type of the button */
  type: PropTypes.oneOf(["submit", "reset", "button"]),

  /** If the button should be disabled */
  disabled: PropTypes.bool,

  /** The link that the button should navigate to on click */
  href: PropTypes.string
};
export default A11y;